import { useState } from "react";
import { sendContactMessage } from "../api/contactApi";

export function useContactForm(initialValues, extraPayload = {}) {
  const [formData, setFormData] = useState(initialValues);
  const [status, setStatus] = useState("idle");

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("loading");

    try {
      await sendContactMessage({
        ...formData,
        ...extraPayload,
      });

      setStatus("success");
      setFormData(initialValues);
    } catch (error) {
      console.error(error);
      setStatus("error");
    }
  };

  return {
    formData,
    status,
    handleChange,
    handleSubmit,
  };
}
